export const APP_VERSION = '14.1.0';
export const APP_SETTING_MAIN_PARTY_KEY = 'main-party';
export const APP_SETTING_THUMBNAIL_RESOLUTION = 'thumbnail-resolution';
export const APP_SETTING_THUMBNAIL_FREQUENCY = 'thumbnail-frequency';
export const SETTING_MIN_APP_VERSION = 'min-app-version';
export const APP_TITLE_BASE = 'Backroom';

export const PING_FREQUENCY = 5;

export const VIDEO_ASPECT_RATIO = 16 / 9;
export const DANCING_VIDEO_HEIGHT = 0.3;
export const NON_DANCING_VIDEO_HEIGHT = 0.3;
export const MAX_BUBBLE_SIZE = 140;
export const MAX_VIDEO_CONNECTION_RETRY_ATTEMPTS = 5;
export const AREA_PADDING = 30;
export const DANCE_FLOOR_PADDING_SIDE = 70; // Allows twitch controllers
export const MAX_MESSAGES_SHOWN = 100;
export const MAIN_AREA_HEIGHT = '30%';

export const TO_LOUNGE_FROM_TWITCH_VOLUME = 0.1;
export const CHAT_WIDTH = 300;

export const GAMES_ENABLED = false;

export const AREA_COLOR = {
  'dance-floor': 'hsla(100, 100%, 50%, 0.2)',
  'lounge-9': '   hsla(130, 100%, 50%, 0.2)',
  'lounge-6': '   hsla(160, 100%, 50%, 0.2)',
  'lounge-3': '   hsla(190, 100%, 50%, 0.2)',
  'lounge-0': '   hsla(220, 100%, 50%, 0.2)',
  'lounge-8': '   hsla(250, 100%, 50%, 0.2)',
  'lounge-5': '   hsla(380, 100%, 50%, 0.2)',
  'lounge-2': '   hsla(310, 100%, 50%, 0.2)',
  'lounge-7': '   hsla(340, 100%, 50%, 0.2)',
  'lounge-4': '   hsla(010, 100%, 50%, 0.2)',
  'lounge-1': '   hsla(040, 100%, 50%, 0.2)',
  'lounge-10': '  hsla(070, 100%, 50%, 0.2)',
};

export const ZINDEX_CHAT = 12;

export const ZINDEX_UI = 11;
export const ZINDEX_PARTICIPANTS = 9;
export const ZINDEX_TWITCH = 1;
export const ZINDEX_AREA_BACKGROUND = 2;
export const ZINDEX_MODAL = 100000000;
export const SELF_VIDEO_SIZE_PX = 48;

export const DEBUG_NAME = 'DebugLocalUser';

export type IAreaChannelAllowed = 'muted' | 'allowed' | 'mandatory';
